import {getAppTracer} from '../../../app.tracer';
import {postMessageMethod} from '@techsee/techsee-common/lib/constants/account.constants';
import {ITranslate} from '../../services/LocalizationService';
import {IJsApiService, IJsApiServiceSettings} from '../../services/JsApiService';

const trace = getAppTracer('EmbeddedDashboardGeneralErrorController');

export interface IEmbeddedDashboardGeneralErrorController {
    readonly translate: ITranslate;
}

export class EmbeddedDashboardGeneralErrorController implements IEmbeddedDashboardGeneralErrorController {
    private readonly _translate: ITranslate;

    constructor(translate: ITranslate, jsApiService: IJsApiService, tsLocaleHelper: any) {
        trace.error('Got to embedded dashboard general error page');

        this._translate = translate;

        // Initialize JS API service
        jsApiService.init(() => {}, {
            enabled: true,
            method: postMessageMethod.IFrame,
            SSOStatusCheck: true,
            dashboardErrorPageLoadedCheck: true
        } as Partial<IJsApiServiceSettings> as IJsApiServiceSettings);

        jsApiService.dashboardErrorPageLoaded();
    }

    get translate(): ITranslate {
        return this._translate;
    }
}
